import BaseModel from './base-model';

export default class Attachment extends BaseModel {
  constructor(opts = {}) {
    super(opts);
    this.id = opts['@id'];
    this.name = opts.attmnt_name;
  }
}
